import React from "react";

import "./ScoreFrame.scss";

type Props = {
  value: number;
  label: string;
}

const GameScoreFrame = ({ value, label }: Props) => {
  return (
    <div className="game-score-frame">
      <header>{label}</header>
      <div className="score">{value}</div>
    </div>
  );
}

export default GameScoreFrame;
